<div class="routing__map">
    <div class="routing__map--standard-map" [ngClass]="{'map-visible':currentStep===1}">
        <app-standard-map [options]="mapOptions"></app-standard-map>
    </div>
    <app-routing-change-orders *ngIf="currentStep===1" [form]="form" (refreshMap)="refreshMap($event)"
        class="routing__map--form" (emitNextStep)="setCurrentStep($event)"></app-routing-change-orders>
    <app-routing-create-cargo *ngIf="currentStep===2" [form]="form" (emitLastStep)="setCurrentStep($event)"
        class="routing__map--form"></app-routing-create-cargo>
</div>